// extracted by mini-css-extract-plugin
export default {"modal_wrapper":"O2JE3uHiRcH_-j2tvJOFE","modal_message":"QC32GHGb0zlw0tvnxj-Xr","modal_text":"_10ImZ6iS_xG6vGTt1S2XTo","btn_modal":"_1IOe1wDK9sSJR9Kc3KtOKN"};